export function Disclaimer() {
  return (
    <p className="text-body color-subtle p-8 text-center">
      By continuing, you agree to our <TermsLink /> and <PrivacyLink />
    </p>
  )
}

function TermsLink() {
  return (
    <a
      className="underline"
      href="https://www.rundoo.ai/terms"
      target="_blank"
      rel="noreferrer"
    >
      Terms &amp; Conditions
    </a>
  )
}

function PrivacyLink() {
  return (
    <a
      className="underline"
      href="https://www.rundoo.ai/privacy"
      target="_blank"
      rel="noreferrer"
    >
      Privacy Notice
    </a>
  )
}
